type Id = string | number;

type CellProperties = Exclude<Properties, { type: 'matchControl' }>;
type Cell = CellProperties & { value: string | number | PropertyValue[] };

export const isCellProperty = (p: Properties): p is CellProperties => p.type !== 'matchControl';

type RepeaterRow = Omit<Repeater, 'onChangeRows'>;
type Row = Cell | RepeaterRow;
type Items = { [key: Id]: Row };

type Repeater = {
  id: Id;
  items: Items[];
  onChangeRows: (id: Id, rowIndex: number, rows: Items[]) => void;
  handleSelectMedia?: (
    properties: ImageProperties,
    handleSelectValue?: (value: string) => void
  ) => void;
  direction?: 'horizontal' | 'vertical';
  parentRowIndex?: number;
  isDisabled?: boolean;
  name?: string;
  className?: string;
  excludedIds?: Id[];
};

type RepeaterSortProps = {
  id: string;
  item: Items;
};

export type {
  Repeater as RepeaterProps,
  RepeaterSortProps,
  Items,
  Row,
  Cell,
  CellProperties,
  Id,
  RepeaterRow,
};
